// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".PremiumText-cls1__f0dda2d627900e59ad73{/*!*/}.PremiumText-cls2__ae56a3ba07abf90f1692{margin-right:8px;width:22px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"cls1": "PremiumText-cls1__f0dda2d627900e59ad73",
	"cls2": "PremiumText-cls2__ae56a3ba07abf90f1692 PremiumText-cls1__f0dda2d627900e59ad73"
};
export default ___CSS_LOADER_EXPORT___;
